import { type ReactNode } from 'react';
import { Tag as TagIcon } from '@hungryroot/icons';
import { usePromoData, parsePromo } from '@hungryroot/promos';
import { Text } from '@hungryroot/ramen';

import styles from './Cyo.module.css';

interface Props {
  header: ReactNode;
  className?: string;
  showPromo?: boolean;
}

export function Cyo({ header, className, showPromo = true }: Props) {
  const promoData = usePromoData({ page: '/limited-time/' });

  const { data } = promoData;
  const parsed = data === undefined ? undefined : parsePromo(data);

  return (
    <div className={className}>
      {header}
      {showPromo && parsed !== undefined && (
        <div className={styles.promo}>
          <TagIcon />
          <div data-promo>
            {parsed.parts.map((part) => {
              switch (part.type) {
                case 'static': {
                  return <Text key={part.text}>{part.text}</Text>;
                }
                case 'effect_base': {
                  return (
                    <Text
                      weight="heavy"
                      key={part.text}
                    >{` ${part.text} `}</Text>
                  );
                }
              }
            })}
          </div>
        </div>
      )}
    </div>
  );
}
